













import PopupEpisode2 from '@/views/templates/tenugui/PopupEpisode2.vue'

export default
  components: {
    PopupEpisode2
  }

  data: () ->
    message: [
      '軽くてかさばらず、乾きも早くて便利なてぬぐいは、キャンプ用品として魅力的。'
      '手を「拭く」、食器を「拭く」といった基本的な使い道から、日焼け防止や熱中症対策、鍋つかみとしてなど、さまざまな用途でご利用いただける万能アイテムです。'
    ]

  methods: {
    closePopup: () ->
      @$emit('closePopup')
    add_point: (point) ->
      @$emit('addPoint', point)
  }
